module.exports = __webpack_public_path__ + "static/media/sf_attraction_7.bff64f47.jpg";